import Glide, {
	Controls,
	Breakpoints,
	Autoplay,
} from '@glidejs/glide/dist/glide.modular.esm';

function syncGlide(master, slave, slave2) {
	master.on('run', function (e) {
		slave2.go(e.direction);
		slave.go(e.direction);
	});
}
const Tabbed = {
	init() {
		// var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

		if (document.querySelectorAll('.tabbed-galleries').length) {
			const gridded = document.querySelectorAll(
				'.tabbed-galleries .gridded'
			);
			gridded.forEach((_glide) => {
				const lightbox = _glide.querySelector('.lightbox');
				let lightboxslider = new Glide(lightbox, {
					hoverpause: false,
					type: 'carousel',
					autoplay: false,
					animationDuration: 700,
					animationTimingFunc:
						'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
				});
				lightboxslider.mount({ Controls, Breakpoints, Autoplay });
				const thumbs = _glide.querySelectorAll('.thumbnails .thumb');
				if (thumbs.length > 0) {
					let thumbnails = new Glide(
						_glide.querySelector('.thumbnails'),
						{
							hoverpause: false,
							type: 'slider',
							bound: true,
							autoplay: false,
							animationDuration: 700,
							perView: 7,
							gap: 20,
							animationTimingFunc:
								'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
							breakpoints: {
								820: {
									perView: 3,
									peek: {
										before: '0px',
										after: '60px',
									},
								},

								1200: {
									perView: 5,
									peek: {
										before: '20px',
										after: '20px',
									},
								},
							},
						}
					);
				}

				const triggers = _glide.querySelectorAll('.image');
				triggers.forEach((trigger, index) => {
					trigger.addEventListener('click', function (e) {
						const lightbox = _glide.querySelector('.lightbox');
						lightbox.classList.add('active');
						lightboxslider.go('=' + index);
					});
				});
			});

			const glide = document.querySelectorAll(
				'.tabbed-galleries .slider'
			);
			glide.forEach((_glide) => {
				let main = new Glide(_glide, {
					hoverpause: false,
					type: 'carousel',
					autoplay: false,
					animationDuration: 700,
					animationTimingFunc:
						'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
				});
				main.mount({ Controls, Breakpoints, Autoplay });
				const lightbox = _glide.querySelector('.lightbox');
				let lightboxslider = new Glide(lightbox, {
					hoverpause: false,
					type: 'carousel',
					autoplay: false,
					animationDuration: 700,
					animationTimingFunc:
						'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
				});
				lightboxslider.mount({ Controls, Breakpoints, Autoplay });
				const thumbs = _glide.querySelectorAll('.thumbnails .thumb');
				if (thumbs.length > 0) {
					let thumbnails = new Glide(
						_glide.querySelector('.thumbnails'),
						{
							hoverpause: false,
							type: 'slider',
							autoplay: false,
							animationDuration: 700,
							perView: 7,
							gap: 20,
							bound: true,
							animationTimingFunc:
								'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
							breakpoints: {
								820: {
									perView: 3,
									peek: {
										before: '0px',
										after: '60px',
									},
								},

								1200: {
									perView: 5,
									peek: {
										before: '20px',
										after: '20px',
									},
								},
							},
						}
					);

					thumbnails.mount({ Breakpoints, Autoplay });
					//syncGlide(main, thumbnails, lightboxslider);
					thumbs.forEach((thumb, index) => {
						thumb.addEventListener('click', function (e) {
							if (thumb.classList.contains('active')) {
								main.go('<');
								lightboxslider.go('<');
							} else {
								let idx =
									thumb.attributes['data-slidenav'].value;
								idx = idx.replace('=', '');

								// thumbnails.go('=' + idx);
								main.go('=' + idx);
								lightboxslider.go('=' + idx);
							}
							e.preventDefault();
						});
					});
					main.on('swipe.end', function () {
						thumbnails.go('=' + main.index);

						thumbs.forEach((thumb) => {
							thumb.classList.remove('active');
						});
						thumbs[main.index].classList.add('active');
					});
					main.on('move.after', function () {
						thumbnails.go('=' + main.index);
						thumbs.forEach((thumb) => {
							thumb.classList.remove('active');
						});
						thumbs[main.index].classList.add('active');
					});
				}

				const trigger = _glide.querySelector('.trigger-lightbox');

				trigger.addEventListener('click', function (e) {
					const lightbox = _glide.querySelector('.lightbox');
					lightbox.classList.add('active');
					lightboxslider.go('=' + main.index);
				});
			});

			const buttons = document.querySelectorAll(
				'.tabbed-galleries .controls-buttons button'
			);
			const controls = document.querySelector('.controls-buttons');
			const dropdown = document.querySelector('.dropdown');
			if (dropdown) {
				dropdown.addEventListener('click', function () {
					controls.classList.toggle('active');
				});
			}
			buttons.forEach((button) => {
				button.addEventListener('click', function (e) {
					const _id = this.id;

					buttons.forEach((button) => {
						button.classList.remove('active');
					});
					this.classList.add('active');
					let galleries = document.querySelectorAll(
						'.tabbed-galleries .gallery'
					);
					galleries.forEach((gallery) => {
						gallery.classList.remove('active');
					});
					galleries.forEach((gallery) => {
						if (
							gallery.classList.contains(_id) ||
							_id === 'cat-all'
						) {
							gallery.classList.add('active');
						}
					});
					if (window.innerWidth < 820) {
						controls.classList.toggle('active');
						dropdown.innerHTML =
							button.innerHTML + '<div class="hitarea"></div>';
					}
				});
			});
			// view-swapper

			const closers = document.querySelectorAll('.close-lightbox');
			closers.forEach((close) => {
				close.addEventListener('click', function (e) {
					const lightboxes = document.querySelectorAll('.lightbox');
					lightboxes.forEach((lightbox) => {
						lightbox.classList.remove('active');
					});
				});
			});
		}
	},
};

export default Tabbed;
